import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Col, Input, notification, Row, Select, Spin } from "antd";
import useItemsGroupContext from "../../../hooks/useItemsGroupContext";
import ButtonStandard from "../../../components/utils/button";
import { Container, Footer } from "../form/styles";
import { classify } from "../../../services/itemsGroupService";

const { Option } = Select;

const ItemsGroupClassify = () => {
  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const {
    isClassifyDrawerVisible,
    classifyRecord,
    closeClassifyDrawer,
    fetchData,
  } = useItemsGroupContext();

  const [classification, setClassification] = useState(undefined);
  const [isLoadingRequest, setIsLoadingRequest] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);

  function handleAfterVisibleChange(visible) {
    if (visible && classifyRecord) {
      setClassification(classifyRecord.classification || undefined);
      setSubmitAttempted(false);
    }
  }

  function handleClose() {
    setClassification(undefined);
    setSubmitAttempted(false);
    closeClassifyDrawer();
  }

  async function handleSave() {
    setSubmitAttempted(true);
    if (!classification) return;

    setIsLoadingRequest(true);
    try {
      await classify({
        groupId,
        farmId,
        id: classifyRecord.id,
        classification,
      });
      notification.success({
        message: translation.itemsGroup.classify.successMessage,
      });
      fetchData();
      handleClose();
    } catch (error) {
      notification.error({
        message: translation.itemsGroup.classify.errorMessage,
      });
    } finally {
      setIsLoadingRequest(false);
    }
  }

  const record = classifyRecord || {};

  return (
    <Container
      title={translation.itemsGroup.classify.title}
      width={700}
      onClose={handleClose}
      maskClosable={false}
      visible={isClassifyDrawerVisible}
      afterVisibleChange={handleAfterVisibleChange}
    >
      <Spin spinning={isLoadingRequest}>
        <div className="drawerForm">
          <Row type="flex" className="rowLabel">
            <label>{translation.itemsGroup.classify.name}</label>
          </Row>
          <Row type="flex">
            <Input value={record.name || ""} disabled />
          </Row>

          <Row type="flex" className="rowLabel">
            <label>{translation.itemsGroup.classify.description}</label>
          </Row>
          <Row type="flex">
            <Input value={record.description || ""} disabled />
          </Row>

          {record.externalIntegrationCode && (
            <>
              <Row type="flex" className="rowLabel">
                <label>
                  {translation.itemsGroup.classify.externalIntegrationCode}
                </label>
              </Row>
              <Row type="flex">
                <Input value={record.externalIntegrationCode} disabled />
              </Row>
            </>
          )}

          <Row type="flex" className="rowLabel">
            <label>{translation.itemsGroup.classify.groupItemName}</label>
          </Row>
          <Row type="flex">
            <Input value={record.groupItemName || ""} disabled />
          </Row>

          <Row type="flex" className="rowLabel">
            <label>{translation.itemsGroup.classify.status}</label>
          </Row>
          <Row type="flex">
            <Input
              value={
                record.status === "Active"
                  ? translation.status.active
                  : record.status === "Classified"
                    ? translation.status.classified
                    : translation.status.inactive
              }
              disabled
            />
          </Row>

          <Row type="flex" className="rowLabel">
            <label
              className={submitAttempted && !classification ? "error" : ""}
            >
              {translation.itemsGroup.classify.classification} *
            </label>
          </Row>
          <Row type="flex">
            <Select
              style={{ width: "100%" }}
              value={classification}
              placeholder={
                translation.itemsGroup.classify.classificationPlaceholder
              }
              onChange={(value) => setClassification(value)}
            >
              <Option value="SUPPLEMENT">
                {translation.itemsGroup.classify.supplement}
              </Option>
              <Option value="VETERINARY_SUPPLEMENT">
                {translation.itemsGroup.classify.veterinarySupplement}
              </Option>
            </Select>
          </Row>
        </div>

        <Footer>
          <Row type="flex">
            <Col span={24} className="buttonsDiv">
              <ButtonStandard
                type="button"
                buttonType="type7"
                onClick={handleClose}
              >
                {translation.buttons.cancel}
              </ButtonStandard>
              <ButtonStandard
                type="button"
                buttonType="type6"
                onClick={handleSave}
              >
                {translation.buttons.save}
              </ButtonStandard>
            </Col>
          </Row>
        </Footer>
      </Spin>
    </Container>
  );
};

export default ItemsGroupClassify;
